import React from 'react'
import { HelpText } from '__components'

export default function ValidationError({ message }) {
  if (message && message.join) {
    message = message.join(' ')
  }
  return message ? <HelpText error>{message}</HelpText> : null
}
